import { GridColDef } from '@mui/x-data-grid-premium'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type NumberColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'number'> & {
  columnType: 'number'
  editable?: boolean
  renderCell?: GridColDef<T>['renderCell']
  validation?: {
    min?: number
    max?: number
  }
}

export const getNumberColumn = <T extends GridValidRowModel>({
  style,
  validation,
  ...config
}: NumberColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupable: false,
  type: 'number',
  preProcessEditCellProps: (params) => {
    const value = params.props.value
    const hasMinError = validation?.min !== undefined && value < validation.min
    const hasMaxError = validation?.max !== undefined && value > validation.max
    return { ...params.props, error: hasMinError || hasMaxError }
  },
})
